"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApTopCategoryComparisonWidget = void 0;
var React = require("react");
var ApLoaderDefault_1 = require("../../ApLoaderDefault");
var ApLoaderText_1 = require("../../ApLoaderText");
var ApWidgetBigValue_1 = require("../ApWidgetBigValue");
var ApWidgetBullet_1 = require("../ApWidgetBullet");
var ApWidgetCard_1 = require("../ApWidgetCard");
var ApWidgetErrorMessage_1 = require("../ApWidgetErrorMessage");
var ApWidgetName_1 = require("../ApWidgetName");
var ApWidgetValueType1_1 = require("../ApWidgetValueType1");
var styles_1 = require("./styles");
var SMALL_FONT_THRESHOLD = 20;
exports.ApTopCategoryComparisonWidget = function (_a) {
    var _b = _a.config, config = _b === void 0 ? { name: '' } : _b, data = _a.data, dataError = _a.dataError, props = __rest(_a, ["config", "data", "dataError"]);
    var size = '';
    var longestValue = '';
    var _c = __read(React.useState(0), 2), valueElHeight = _c[0], setValueElHeight = _c[1];
    if (data) {
        data.forEach(function (dataItem) {
            if (dataItem.value.toString().length > longestValue.length) {
                longestValue = dataItem.value.toString();
            }
        });
        size = longestValue.length > SMALL_FONT_THRESHOLD ? 's' : 'l';
    }
    return (React.createElement(ApWidgetCard_1.ApWidgetCard, __assign({}, props),
        React.createElement(styles_1.Container, null,
            config && (React.createElement(ApWidgetName_1.ApWidgetName, { name: config.name, iconType: config.iconType })),
            dataError ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApWidgetErrorMessage_1.ApWidgetErrorMessage, null))) : !data ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApLoaderDefault_1.ApLoaderDefault, { loaderText: function () { return React.createElement(ApLoaderText_1.ApLoaderText, null); } }))) : (React.createElement(styles_1.BodyWrapper, { widthRatio: config.widthRatio }, (config.widthRatio === 2 ? data : [data[0]]).map(function (dataItem, index) { return (React.createElement("div", { key: dataItem.value.toString() + index },
                React.createElement(styles_1.VarianceContainer, null, dataItem.value.toString() === longestValue ? (React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, { size: size, setElHeight: setValueElHeight }, dataItem.value)) : (React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, { size: size, height: valueElHeight }, dataItem.value))),
                React.createElement(styles_1.AverageContainer, null, dataItem.valuePairs.map(function (valuePair, idx) { return (React.createElement(ApWidgetValueType1_1.ApWidgetValueType1, __assign({ key: valuePair.label + idx }, valuePair))); })),
                React.createElement(ApWidgetBullet_1.ApWidgetBulletList, { list: dataItem.attributes }))); }))))));
};
exports.ApTopCategoryComparisonWidget.defaultProps = {
    config: {
        name: '',
    },
    data: null,
};
//# sourceMappingURL=ApTopCategoryComparisonWidget.js.map